import { compose } from 'redux';

import PageCustomizablesApp from 'hb-react/frontoffice/apps/PageCustomizables/startup/PageCustomizablesAppClient';
import { withTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import withDefaultAppContexts from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { dynamicTopicResourcePath } from 'hb-react/shared/apps/Topics/utils';

const TopicCustomPageContainer = ({
  currentUser,
  currentNetwork,
  subdomainNetworkUrl,
  topic,
  topicId,
  whitelabelURL,
}) => (
  <PageCustomizablesApp
    app={currentUser ? 'frontoffice' : 'publicoffice'}
    appPages={topic.app_pages}
    fetchPath={(pageId) =>
      dynamicTopicResourcePath(Routes.topic_page_path(topicId, pageId), {
        whitelabelURL,
        topicId,
      })
    }
    ids={{
      network: currentNetwork.id,
      topic: topicId,
      user: currentUser?.id,
    }}
    legacyContentClassName="container--centered soft-double--bottom soft--top soft--sides"
    redirectUrl={currentNetwork.network_config.redirect_url}
    subdomainNetworkUrl={subdomainNetworkUrl}
    topic={topic}
  />
);

export default compose(
  withDefaultAppContexts,
  withTopicContext,
)(TopicCustomPageContainer);
